import * as types from 'constants/action_types'
import * as accountActionTypes from 'constants/action_types/accounts'
import Api from 'services/api'
import { SETUP_WIZARD_STAGES } from '../constants/setup_wizard'
import { getThirdStage } from '../helpers/setup_wizard'
import { showMwsSyncModal } from './account/mwsSync'
import { createNotification } from './notifications'

export const setSetupWizardStage = ({ stage, stageIndex, ppcRedirectData }) => (
  dispatch,
  getState
) => {
  const { stage: currentStage } = getState().setupWizard

  if (ppcRedirectData || currentStage !== stage) {
    dispatch({
      type: types.SET_SETUP_WIZARD_DATA,
      payload: { stage, stageIndex, ppcRedirectData }
    })
  }
}

export const setSetupWizardData = payload => dispatch => {
  dispatch({
    type: types.SET_SETUP_WIZARD_DATA,
    payload
  })
}

export const updateHasSellerAccount = () => async (dispatch, getState) => {
  const {
    account: {
      userInfo: { isAmazonSeller, isBeginner },
      saveProfile: { isLoading }
    },
    globalData: { trackerCategories }
  } = getState()

  // Disable action when it's running
  if (isLoading) return

  dispatch({
    type: accountActionTypes.PENDING_ACCOUNT_ACTION,
    payload: 'saveProfile'
  })

  const nextStage = getThirdStage({
    isAmazonSeller,
    isBeginner,
    trackerCategories
  })

  dispatch({
    type: types.SET_SETUP_WIZARD_DATA,
    payload: nextStage
  })

  const res = await Api.updateProfile({
    is_amazon_seller: isAmazonSeller,
    seller_stage: isBeginner ? 'not_selling' : 'new_seller',
    wizard_completed: true
  })

  if (!res.ok) {
    dispatch({
      type: types.SET_SETUP_WIZARD_DATA,
      payload: SETUP_WIZARD_STAGES[1]
    })
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: 'Setup Error:'
      })
    )
  }

  dispatch({
    type: accountActionTypes.RESET_ACCOUNT_ACTION,
    payload: 'saveProfile'
  })
}

export const fetchProduct = () => async (dispatch, getState) => {
  const { marketplace, asin } = getState().setupWizard

  const asinRegex = /^([A-Z0-9]{10})$/gi

  if (!asinRegex.test(asin)) {
    dispatch({
      type: types.SET_SETUP_WIZARD_DATA,
      payload: {
        asinError: 'Sorry, we cannot find that ASIN. Please try another.'
      }
    })

    return
  }

  dispatch({
    type: types.PENDING_SETUP_WIZARD_ACTION,
    payload: 'fetchAsin'
  })

  const res = await Api.refreshProduct({ asin, amz_store: marketplace })

  if (res.ok) {
    if (res.data.name) {
      dispatch({
        type: types.SET_SETUP_WIZARD_DATA,
        payload: { product: res.data }
      })
    } else {
      dispatch({
        type: types.SET_SETUP_WIZARD_DATA,
        payload: {
          asinError: 'Sorry, we cannot find that ASIN. Please try another.'
        }
      })
    }
  } else {
    dispatch({
      type: types.SET_SETUP_WIZARD_DATA,
      payload: {
        asinError: res.error
      }
    })
  }

  dispatch({
    type: types.RESET_SETUP_WIZARD_ACTION,
    payload: 'fetchAsin'
  })
}

export const seedFeatures = (isSeller = false) => async (
  dispatch,
  getState
) => {
  const {
    marketplace: country,
    asin,
    seedFeatures: { isLoading }
  } = getState().setupWizard

  // Disable action when it's running
  if (isLoading) return

  dispatch({
    type: types.PENDING_SETUP_WIZARD_ACTION,
    payload: 'seedFeatures'
  })

  const requestParams = isSeller
    ? { features: ['alerts', 'rank_tracker'], is_seller: true }
    : {
        products: [{ country, asin, source: 'product_tracker' }],
        features: ['product_tracker', 'alerts', 'keyword_list'],
        is_seller: false
      }

  const res = await Api.seedFeatures(requestParams)

  if (res.ok) {
    dispatch({
      type: types.SET_SETUP_WIZARD_DATA,
      payload: { stage: 'extensionInfo', stageIndex: 4 }
    })
    if (isSeller) {
      dispatch(showMwsSyncModal(null))
    }
  } else {
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: 'Setup Error:'
      })
    )
  }

  dispatch({
    type: types.RESET_SETUP_WIZARD_ACTION,
    payload: 'seedFeatures'
  })
}

export const updateSellerType = async (newState, dispatch) => {
  dispatch({
    type: types.UPDATE_INFO_SELLER_TYPE,
    payload: newState
  })
}

export const updateIsSelling = async (newState, dispatch) => {
  dispatch({
    type: types.UPDATE_INFO_IS_SELLING,
    payload: newState
  })
}

export const updateSellerAnnualRevenue = (newState, dispatch) => {
  dispatch({
    type: types.UPDATE_INFO_ANNUAL_REVENUE,
    payload: newState
  })
}

export const resetStoreSellerInfo = (infoType, dispatch) => {
  dispatch({
    type: types.RESET_STORE_SELLER_INFO,
    payload: infoType
  })
}

export const updateSellerInfo = async (
  sellerType,
  isSelling,
  annualRevenue,
  dispatch
) => {
  // Set isUpdating to true in state to disable buttons until api call succeeds
  dispatch({
    type: types.UPDATE_SELLER_INFO_START
  })

  const nextStage = SETUP_WIZARD_STAGES[1]

  dispatch({
    type: types.SET_SETUP_WIZARD_DATA,
    payload: nextStage
  })

  const res = await Api.updateProfile({
    seller_type: sellerType,
    is_selling: isSelling,
    annual_revenue: annualRevenue
  })

  if (!res.ok) {
    dispatch({
      type: types.SET_SETUP_WIZARD_DATA,
      payload: SETUP_WIZARD_STAGES[0]
    })
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: 'Setup Error:'
      })
    )
  }

  dispatch({
    type: types.UPDATE_SELLER_INFO_END
  })
}
